module.exports = __webpack_public_path__ + "img/dsci0040.37bf0733.jpg";